const Prop65WarningIcon = ({ className }) => (
  <svg className={className} viewBox={'0 0 37 32'} aria-hidden={'true'} focusable={'false'}>
    <path fill={'#ffd100'} d={'M3.38 29.525l14.902-25.81 14.903 25.81z'} />
    <path
      fill={'#000'}
      d={
        'M36.401 30.15l-17.051-29.533c-0.217-0.371-0.614-0.617-1.068-0.617s-0.851 0.245-1.065 0.611l-0.003 0.006-17.051 29.533c-0.104 0.177-0.165 0.39-0.165 0.617 0 0.68 0.55 1.232 1.23 1.234h34.105c0.68-0.002 1.23-0.554 1.23-1.234 0-0.227-0.061-0.44-0.168-0.622l0.003 0.006zM3.38 29.525l14.902-25.81 14.903 25.81z'
      }
    />
    <path
      fill={'#000'}
      d={
        'M19.49 24.461c0.667 0.667 0.667 1.748 0 2.414s-1.748 0.667-2.414 0c-0.667-0.667-0.667-1.748 0-2.414s1.748-0.667 2.414 0z'
      }
    />
    <path
      fill={'#000'}
      d={
        'M16.878 8.801c-0.547 0.423-0.896 1.079-0.896 1.817 0 0.201 0.026 0.396 0.075 0.582l-0.004-0.016 1.273 11.088c0.051 0.512 0.479 0.908 0.999 0.908 0.555 0 1.004-0.45 1.004-1.004 0-0.048-0.003-0.096-0.010-0.142l0.001 0.005 1.224-11.173c0.009-0.075 0.014-0.161 0.014-0.249 0-1.263-1.024-2.288-2.288-2.288-0.526 0-1.011 0.178-1.398 0.477l0.005-0.004z'
      }
    />
  </svg>
)

export default Prop65WarningIcon
